import ImageCompare from "image-compare-viewer";

export default function () {
    const viewers = document.querySelectorAll(".image-compare");
    viewers.forEach((element) => {
        new ImageCompare(element).mount();
    });
}
